const TableContent = [
  {
    PersonImg: "Person.png",
    FirstName: "Olivia Rhye",
    LastName: "@olivia",
    Usertype: "Standard",
    Email: "mail@email.com",
    Twitter: "@olivia",
    Insta: "@olivia",
    TotalNFT: "10",
  },
  {
    PersonImg: "Person-1.png",
    FirstName: "lana",
    LastName: "@phoenix",
    Usertype: "creative",
    Email: "mail@gmail.com",
    Twitter: "@phoenix",
    Insta: "@phoenix",
    TotalNFT: "12",
  },
  {
    PersonImg: "Person-2.png",
    FirstName: "Lana Steiner",
    LastName: "@lana",
    Usertype: "Standard",
    Email: "mail@email.com",
    Twitter: "@lana",
    Insta: "@lana",
    TotalNFT: "08",
  },
  {
    PersonImg: "Person-4.png",
    FirstName: "Demi Wilkinson",
    LastName: "@demi",
    Usertype: "Standard",
    Email: "mail@email.com",
    Twitter: "@demi",
    Insta: "@demi",
    TotalNFT: "12",
  },
  {
    PersonImg: "Person-5.png",
    FirstName: "Candice Wu",
    LastName: "@candice",
    Usertype: "Standard",
    Email: "mail@email.com",
    Twitter: "@candice",
    Insta: "@candice",
    TotalNFT: "22",
  },
  {
    PersonImg: "Person-6.png",
    FirstName: "Natali Craig",
    LastName: "@natali",
    Usertype: "Standard",
    Email: "mail@email.com",
    Twitter: "@natali",
    Insta: "@natali",
    TotalNFT: "9",
  },
];
export { TableContent };
